import React from "react";
import { Box, Typography, Avatar, Slide } from "@mui/material";
import useUserInfoStyles from "../../instructionStyle/default/userInfoStyle";

const UserInfo = ({ user, isOpen }) => {
  const classes = useUserInfoStyles();

  return (
    <Slide direction="right" in={isOpen} mountOnEnter unmountOnExit>
      <Box
        className={`${classes.userInfoContainer} ${
          isOpen
            ? classes.userInfoContainerOpen
            : classes.userInfoContainerClosed
        }`}
      >
        <div className={classes.profileImagecontainer}>
          <img
            src={user.image}
            alt="Profile IMG"
            className={classes.profileImage}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = "userAvatar.png";
            }}
          />
        </div>
        <Box className={classes.userInfoText}>
          <Typography variant="body1" className={classes.responsiveText}>
            <strong>Exam Name:</strong> {user.examName}
          </Typography>
          <Typography variant="body1" className={classes.responsiveText}>
            <strong>Exam Duration:</strong> {user.duration} Minutes
          </Typography>
          {user.rollNumber === "" ||
          user.rollNumber === null ||
          user.rollNumber === "undefined" ? (
            <></>
          ) : (
            <Typography variant="body1" className={classes.responsiveText}>
              {/* <strong>Allen Form Number:</strong> {user.rollNumber} */}
              <strong>Roll Number :</strong> {user.rollNumber}
            </Typography>
          )}
          <Typography variant="body1" className={classes.responsiveText}>
            <strong>Candidate Name:</strong> {user.candidateName}
          </Typography>
          {(user.rollNumber === "" ||
            user.rollNumber === null ||
            user.rollNumber === "undefined") && (
            <Typography variant="body1" className={classes.responsiveText}>
              <strong>Mobile Number:</strong> {user.mobile}
            </Typography>
          )}
        </Box>
      </Box>
    </Slide>
  );
};

export default UserInfo;
